import { useProfile } from "@/context/ProfileContext";
import { useRemoteConfigBoolean } from "@/context/RemoteConfigContext";
import { hasProductAccessWithFallback } from "@/utils/productAccess";

/**
 * Single source of truth for "this business can use Intelligence right now".
 *
 * Dual gate: the `show_intelligence` remote-config flag (feature availability)
 * AND the paid `intelligence` product entitlement (`intelligence` has no legacy
 * fallback, so this is an explicit entitlement check). Use this anywhere the
 * dashboard decides between the live agent and the upsell teaser.
 */
export function useIntelligenceAccess(): boolean {
  const { businessProfile, memberAccessLevel } = useProfile();
  const showIntelligence = useRemoteConfigBoolean("show_intelligence");
  return (
    showIntelligence &&
    // Report-only accounts (GRA-96) get no Coach, Pulse or people surfaces.
    memberAccessLevel !== "none" &&
    businessProfile != null &&
    hasProductAccessWithFallback(businessProfile, "intelligence", Date.now())
  );
}
